<script setup>
import ContentListItem from './ContentListItem'
import {defineProps} from 'vue'

let props = defineProps({
    content_list: Array
})
</script>

<template>
    <div class="container mx-auto max-w-5xl px-4 ">
        <ContentListItem v-for="(content, index) in props.content_list" :index="index" :content="content" :key="content.id"/>
        <div v-if="!props.content_list.length" class="text-center py-4">
            {{ $tt('my_portal_page__no_content_found') }}
        </div>
    </div>
</template>

<style scoped>

</style>
